<template>
    <div class="ofb-vert" v-on:click="goToURL()">
        <div class="vert-content-container">
            <v-avatar tile style="margin-right: 1rem;">
                <img :src="image" alt="alt">
            </v-avatar>

            <div class="vert-text-container">
                <h3>{{title}}</h3>
                <p>{{description}}</p>
            </div>
        </div>

        <div class="vert-action-box">
            <v-icon>launch</v-icon>
            <span>Ads by OFB</span>
        </div>
    </div>
</template>

<script>

export default {
    name: "Vert",

    props: {
        image: String,
        title: String,
        description: String,
        url: String
    },

    components: {

    },

    methods: {
        goToURL: function () {
            window.open(this.url);
        }
    },

    data: () => ({

    }),
}
</script>

<style scoped>

    h3 {
        font-size: 16px;
        margin: 0;
    }

    p {
        font-size: 12px;
        margin: 0;
    }

    span {
        font-size: 10px;
    }

    .ofb-vert {
        height: 70px;
        width: 100%;

        display: grid;
        grid-template-columns: 2fr auto;
        justify-content: center;
        align-items: center;

        padding: 0 16px;
        border: solid #727272 1px;
        border-radius: 4px;
        transition: background-color ease 200ms;
    }

    .ofb-vert:hover {
        background-color: #323232;
        cursor: pointer;
    }

    .vert-content-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        overflow-x: hidden;
        text-overflow: clip;
    }

    .vert-action-box {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: flex-end;
        justify-self: end;
        width: 40px;
    }

    .vert-text-container {
        min-width: 100%;
    }

    @media screen and (min-width: 1000px) {
        .vert-action-box {
            width: 100px;
        }
    }
</style>